import React from 'react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import Logo from '@svg/logo-new.svg';

import { CTA, CTAmobile } from './CTA';
import { SmallLinks, MainLinks, Socials, Supporters } from './footerLinks';

const Footer = () => {
  const breakpoints = useBreakpoint();
  return (
    <div className='py-10 md:py-24 grid grid-cols-14 relative z-1'>
      <div className='col-start-1 col-end-15 px-gutter md:px-14 lg:pb-24'>
        {breakpoints.lg ? <CTA /> : <CTAmobile />}
      </div>

      <div className='col-start-2 lg:col-start-1 lg:col-end-6 col-end-14 lg:pl-16 flex flex-col justify-between'>
        {breakpoints.lg && (
          <>
            <Logo className='w-[333px]' />
            <SmallLinks />
          </>
        )}
      </div>

      <div className='col-start-2 lg:col-start-7 col-end-14 lg:col-end-15 lg:pr-16 flex flex-col justify-between text-white'>
        {breakpoints.lg && <MainLinks />}
        <Socials />
        <Supporters />
        {!breakpoints.lg && (
          <>
            <Logo className='w-[245px] mx-auto mt-14' />
            <SmallLinks />
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
